import {
  ISetRegionIdParameters,
  IOpenAuthModalParameters,
} from '../../repositories/header-frontend/v1/get-header-microfrontend/microfrontend/api/v1/set-region-id/types';

export interface IHeaderMicrofrontendAPI {
  setRegionId(parameters: ISetRegionIdParameters): Promise<void>;
  openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void>;
}

export interface IDesktopFiltersMicrofrontendAPI {
  openDatesPopup(): Promise<void>;
}

export enum ESearchStringView {
  /** Полноразмерная строка с перебором интентов. */
  SearchString = 'searchString',
  /** Компактная кнопка с иконкой поиска. */
  Button = 'button',
}

export interface ISearchStringMicrofrontendAPI {
  setView(view: ESearchStringView): Promise<void>;
  disablePlaceholders(): Promise<void>;
}

export interface IMicrofrontendsAPI {
  header?: IHeaderMicrofrontendAPI;
  desktopFilters: IDesktopFiltersMicrofrontendAPI;
  searchString: ISearchStringMicrofrontendAPI;
}
